import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { dealsApi } from '../../../services/api';
import { showSuccess } from '../../../utils/toast';

export const useConvertToDeal = (setError: (msg: string | null) => void) => {
  const navigate = useNavigate();
  const [converting, setConverting] = useState<number | null>(null);

  const handleConvert = async (requestId: number) => {
    try {
      setConverting(requestId);
      const response = await dealsApi.convertFromRequest(requestId);

      // Show success toast
      showSuccess('Project request converted to deal successfully!');

      // Get the created deal ID from response
      const newDealId = (response as any)?.deal?.id || (response as any)?.id;

      // Redirect to deals page with highlight parameter
      navigate(`/deals?highlight=${newDealId}`);
    } catch (e: any) {
      setError(e?.response?.data?.message || e?.message || 'Conversion failed');
    } finally {
      setConverting(null);
    }
  };

  return { converting, handleConvert };
};
